var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$isWeb ? 'pool-h5': 'pool'},[_c('Tabs',{attrs:{"tabs":_vm.tabs,"itemClick":_vm.tabItemClick}}),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.server))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }